export enum BulkRequestTypeEnum {
  // ReturnToStock = 1,
  // ReviewPricelistSource = 2,
  // ReviewStockSource = 3,
  // MarkAsReady = 4,
  // MarkAsCollected = 5,
  // GeneratePurchaseOrder = 6,
  ReturnToStock = 'ReturnToStock',
  ReviewPricelistSource = 'ReviewPricelistSource',
  ReviewStockSource = 'ReviewStockSource',
  MarkAsReady = 'MarkAsReady',
  MarkAsCollected = 'MarkAsCollected',
  GeneratePurchaseOrder = 'GeneratePurchaseOrder',
}

export const getBulkRequestTypeLabel = (type?: BulkRequestTypeEnum | null): string | null => {
  switch (type) {
    case BulkRequestTypeEnum.ReturnToStock:
      return 'Return to stock';
    case BulkRequestTypeEnum.ReviewPricelistSource:
      return 'Review pricelist source';
    case BulkRequestTypeEnum.ReviewStockSource:
      return 'Review stock source';
    case BulkRequestTypeEnum.MarkAsReady:
      return 'Mark as Ready';
    case BulkRequestTypeEnum.MarkAsCollected:
      return 'Mark as Collected';
    case BulkRequestTypeEnum.GeneratePurchaseOrder:
      return 'Create purchase order';
    default:
      return null;
  }
};

export const getBulkRequestActionLabel = (type?: BulkRequestTypeEnum | null): string | null => {
  switch (type) {
    case BulkRequestTypeEnum.ReviewStockSource:
      return 'Confirm stock source';
    case BulkRequestTypeEnum.ReviewPricelistSource:
      return 'Confirm pricelist source';
    default:
      return getBulkRequestTypeLabel(type);
  }
};

export const isBulkRequestType = (input?: string | null): input is BulkRequestTypeEnum => {
  if (!input) {
    return false;
  }

  return [
    BulkRequestTypeEnum.ReturnToStock,
    BulkRequestTypeEnum.ReviewPricelistSource,
    BulkRequestTypeEnum.ReviewStockSource,
    BulkRequestTypeEnum.MarkAsReady,
    BulkRequestTypeEnum.MarkAsCollected,
    BulkRequestTypeEnum.GeneratePurchaseOrder,
  ].includes(input as BulkRequestTypeEnum);
};
